import { ModuleConfig } from '@schamburg-web/interfaces';
import { ImageMarker } from '@schamburg-web/lakecounty';
import { getIncidentIcon, getLocationDescription } from '../utils';

const IncidentMarker: React.FC<{
  icon: any;
  module: ModuleConfig;
}> = ({ icon }) => {
  return (
    <ImageMarker
      {...getIncidentIcon(icon)}
      showOutline={false}
      title={getLocationDescription(icon)}
    />
  );
};

export default IncidentMarker;
